import styled from 'styled-components';
import { Select } from 'antd';

interface ShowOptionsProps {
  showiconclose: boolean;
}

export const SelectResponsive = styled(Select)<ShowOptionsProps>`
  display: block;
  width: 100%;

  .ant-select-selection-item-remove {
    display: ${(props) => (props.showiconclose ? 'none' : 'block')};
  }
  .ant-select-item-option-selected {
    pointer-events: ${(props) => (props.showiconclose ? 'none' : 'visible')};
  }

  span.ant-select-selection-item-content {
    max-width: 200px;
    background-color: ${(props) => props.theme.colors.inputSelect};
  }

  @media (max-width: 815px) {
    width: 100%;
  }
`;
